import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ContactInformationRoutingModule } from './contact-information-routing.module';
import { ContactInformationComponent } from './contact-information.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { DirectivesModule } from 'src/app/shared/directives/directives.module';

@NgModule({
  declarations: [ContactInformationComponent],
  imports: [
    CommonModule,
    ContactInformationRoutingModule,
    MatAutocompleteModule,
    MatInputModule,
    ReactiveFormsModule,
    DirectivesModule
  ]
})
export class ContactInformationModule {}
